import React from 'react';
import axios from './axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useGetEmailRegistered(email) {
  const common = v => ({ params: { email: v } });
  const [state, q] = useAxios({
    url: '/api/v1/registrations/check_email_existence',
    method: 'GET',
    ...common(email),
  }, { manual: true });
  const executeQuery = newEmail => q(common(newEmail));
  return [state, executeQuery];
}

export function useGetAccountRegistered(email) {
  const common = v => ({ params: { email: v } });
  const [state, q] = useAxios({
    url: '/api/v1/registrations/check_account_existence',
    method: 'GET',
    ...common(email),
  }, { manual: true });
  const executeQuery = newEmail => q(common(newEmail));
  return [state, executeQuery];
}

export function usePostRegister(params) {
  const common = v => ({ data: { registration: v } });
  const [state, q] = useAxios({
    url: '/api/v1/registrations',
    method: 'POST',
    ...common(params),
  }, { manual: true });
  const executeQuery = React.useCallback(newParams => q(common(newParams)), [q]);
  return [state, executeQuery];
}

export function useGetConfirmToken(token) {
  const common = v => ({ params: { confirmation_token: v } });
  const [state, q] = useAxios({
    url: '/users/confirmation',
    method: 'GET',
    ...common(token),
  }, { manual: true });
  const executeQuery = React.useCallback(newToken => q(common(newToken)), [q]);
  return [state, executeQuery];
}

export function usePostSignIn(params) {
  const common = v => ({ data: { user: { ...v, remember_me: 1 } } });
  const [state, q] = useAxios({
    url: '/users/sign_in.json',
    method: 'POST',
    ...common(params),
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function useGetMyProfile() {
  return useAxios({
    url: '/users/me',
    method: 'GET',
  }, { manual: true });
}

export function usePostForgotPassword(params) {
  const common = v => ({ data: { user: v, authenticity_token: Livewire.formAuthenticityToken } });
  const [state, q] = useAxios({
    url: '/users/password.json',
    method: 'POST',
    ...common(params),
  }, { manual: true });
  const executeQuery = newParams => q(common(newParams));
  return [state, executeQuery];
}

export function usePutPassword() {
  const common = (password, token) => ({
    data: {
      authenticity_token: Livewire.formAuthenticityToken,
      user: { password, reset_password_token: token },
    },
  });
  const [state, q] = useAxios({
    url: '/users/password.json',
    method: 'PUT',
  }, { manual: true });
  const executeQuery = (pw, tok) => q(common(pw, tok));
  return [state, executeQuery];
}
